import { TabStyles } from '@tableau/widgets';
import { CSSProperties } from 'react';
import { CommonStyles } from '../../common/react/CommonStyles';
import { cssClass } from '../../style';

const { Colors, Sizing, Spacing, Typography } = TabStyles;

const cssPrefix = 'UserNotificationSettings';

const leftCell: CSSProperties = {
  paddingLeft: '0 !important',
};

const cell: CSSProperties = {
  verticalAlign: 'middle',
};

export const gridContainer = cssClass(cssPrefix, 'gridContainer', {
});

export const siteSettingsFormContainer = cssClass(cssPrefix, 'siteSettingsFormContainer', {
  marginBottom: Spacing.DefaultSpace,
});

export const headerCell = cssClass(cssPrefix, 'headerCell', {
  fontWeight: 'bold',
  padding: `0 ${CommonStyles.Sizes.MediumSpace}px 0 ${CommonStyles.Sizes.MediumSpace}px`
});

export const groupNameCell = cssClass(cssPrefix, 'groupNameCell', {
  fontWeight: 'bold',
  ...leftCell,
  ...cell,
});

export const bucketNameCell = cssClass(cssPrefix, 'bucketNameCell', {
  fontWeight: 'normal',
  ...leftCell,
  ...cell,
});

export const settingCell = cssClass(cssPrefix, 'setting', {
  textAlign: 'center',
  ...cell,
});

export const buttonCell = cssClass(cssPrefix, 'buttonCell', {
  paddingRight: '0 !important'
});

export const explanationBlock = cssClass(cssPrefix, 'explanation', {
  marginTop: Spacing.ExtraLargeSpace,
  color: Colors.F9,
});